// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KViu","placeholdersHeader":"styles_placeholdersHeader__3vGNW","editorStyle":"styles_editorStyle__22m4w","placeholdersBox":"styles_placeholdersBox__2uO4o"};